import AppConstants from './AppConstants';

export class Utils {
    static filterClientCandidacyStatuses(enums = []) {
        return enums.filter(
            (s) =>
                !AppConstants.clientRestrictedCandidacyStatuses.includes(
                    s.name,
                ),
        );
    }

    static resolveContactCommunicationLevelDescription(communicationLevel) {
        switch (communicationLevel) {
            case 1:
                return '1 (Low)';
            case 2:
                return '2 (Average)';
            case 3:
                return '3 (High)';
            default:
                return '0 (None)';
        }
    }

    static validateUrl(url) {
        if (!url || url.length == 0) return false;

        const urlRegex =
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

        return urlRegex.test(url);
    }

    static validateEmail(email) {
        if (!email || email.trim().length === 0) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailRegex.test(email.trim());
    }

    static deepFlatten(obj) {
        if (obj === null) return null;

        if (typeof obj === 'string') return obj;
        if (typeof obj === 'number') return obj;

        if (Array.isArray(obj)) {
            return obj.map((i) => Utils.deepFlatten(i));
        }

        if (Object.keys(obj).length == 0) {
            return null;
        }

        return Object.keys(obj).reduce((acc, k) => {
            if (['data', 'attributes'].includes(k)) {
                if (obj[k] == null) {
                    return null;
                } else if (Array.isArray(obj[k])) {
                    return Utils.deepFlatten(obj[k]);
                } else if (typeof obj[k] === 'object') {
                    Object.assign(acc, Utils.deepFlatten(obj[k]));
                } else {
                    acc[k] = obj[k];
                }
            } else if (typeof obj[k] === 'object' && obj[k] != null) {
                acc[k] = Utils.deepFlatten(obj[k]);
            } else {
                acc[k] = obj[k];
            }
            return acc;
        }, {});
    }

    static convertEnumStringToLabel(enumStr) {
        if (!enumStr) return;

        return enumStr
            .split('_') // Split by underscore
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            .join(' ');
    }

    static convertDateToDisplayDateString(date) {
        return new Date(date).toLocaleString(undefined, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZoneName: 'short',
        });
    }
}
